"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultLanguages = exports.modalRedirectsLanguagesFelsinea = exports.modalRedirectsLanguagesSirman = exports.chineseExchangeableLanguages = exports.hreflangVariationsFromMain = exports.fallbackMainHreflang = exports.fallbackInternationalization = exports.internationalizationInCatalogs = exports.priorityInternationalization = exports.defaultLanguage = exports.defaultInternationalization = exports.notCurrentAvailableInternationalizationFls = exports.notCurrentAvailableInternationalizationPROD = exports.notCurrentAvailableInternationalization = exports.availableInternationalization = void 0;
const languages_1 = require("../types/languages");
exports.availableInternationalization = {
    CHINESE_SIMPLIFIED_CHINA: `${languages_1.Languages.CHINESE_SIMPLIFIED}-${languages_1.Countries.CHINA}`,
    ENGLISH_UNITED_KINGDOM: `${languages_1.Languages.ENGLISH}-${languages_1.Countries.UNITED_KINGDOM}`,
    ENGLISH_UNITED_STATES: `${languages_1.Languages.ENGLISH}-${languages_1.Countries.UNITED_STATES}`,
    FRENCH_FRANCE: `${languages_1.Languages.FRENCH}-${languages_1.Countries.FRANCE}`,
    GERMAN_GERMANY: `${languages_1.Languages.GERMAN}-${languages_1.Countries.GERMANY}`,
    ITALIAN_ITALY: `${languages_1.Languages.ITALIAN}-${languages_1.Countries.ITALY}`,
    PORTUGUESE_BRAZIL: `${languages_1.Languages.PORTUGUESE}-${languages_1.Countries.BRAZIL}`,
    PORTUGUESE_PORTUGAL: `${languages_1.Languages.PORTUGUESE}-${languages_1.Countries.PORTUGAL}`,
    RUSSIAN_RUSSIA: `${languages_1.Languages.RUSSIAN}-${languages_1.Countries.RUSSIA}`,
    SPANISH_SPAIN: `${languages_1.Languages.SPANISH}-${languages_1.Countries.SPAIN}`,
};
exports.notCurrentAvailableInternationalization = {
    PORTUGUESE_BRAZIL: `${languages_1.Languages.PORTUGUESE}-${languages_1.Countries.BRAZIL}`,
    PORTUGUESE_PORTUGAL: `${languages_1.Languages.PORTUGUESE}-${languages_1.Countries.PORTUGAL}`,
};
exports.notCurrentAvailableInternationalizationPROD = {
    PORTUGUESE_BRAZIL: `${languages_1.Languages.PORTUGUESE}-${languages_1.Countries.BRAZIL}`,
    PORTUGUESE_PORTUGAL: `${languages_1.Languages.PORTUGUESE}-${languages_1.Countries.PORTUGAL}`,
};
exports.notCurrentAvailableInternationalizationFls = {
    CHINESE_SIMPLIFIED_CHINA: `${languages_1.Languages.CHINESE_SIMPLIFIED}-${languages_1.Countries.CHINA}`,
    ENGLISH_UNITED_STATES: `${languages_1.Languages.ENGLISH}-${languages_1.Countries.UNITED_STATES}`,
    FRENCH_FRANCE: `${languages_1.Languages.FRENCH}-${languages_1.Countries.FRANCE}`,
    GERMAN_GERMANY: `${languages_1.Languages.GERMAN}-${languages_1.Countries.GERMANY}`,
    PORTUGUESE_BRAZIL: `${languages_1.Languages.PORTUGUESE}-${languages_1.Countries.BRAZIL}`,
    PORTUGUESE_PORTUGAL: `${languages_1.Languages.PORTUGUESE}-${languages_1.Countries.PORTUGAL}`,
    RUSSIAN_RUSSIA: `${languages_1.Languages.RUSSIAN}-${languages_1.Countries.RUSSIA}`,
    SPANISH_SPAIN: `${languages_1.Languages.SPANISH}-${languages_1.Countries.SPAIN}`,
};
exports.defaultInternationalization = exports.availableInternationalization.ENGLISH_UNITED_KINGDOM;
exports.defaultLanguage = languages_1.Languages.ENGLISH;
exports.priorityInternationalization = [
    exports.availableInternationalization.ENGLISH_UNITED_KINGDOM,
    exports.availableInternationalization.ITALIAN_ITALY
];
exports.internationalizationInCatalogs = {
    [languages_1.Catalogs.WORLDWIDE]: [
        exports.availableInternationalization.ENGLISH_UNITED_KINGDOM,
        exports.availableInternationalization.FRENCH_FRANCE,
        exports.availableInternationalization.ITALIAN_ITALY,
        exports.availableInternationalization.PORTUGUESE_PORTUGAL,
        exports.availableInternationalization.RUSSIAN_RUSSIA,
        exports.availableInternationalization.SPANISH_SPAIN,
    ],
    [languages_1.Catalogs.USA]: [
        exports.availableInternationalization.ENGLISH_UNITED_STATES
    ],
    [languages_1.Catalogs.CHINESE]: [
        exports.availableInternationalization.CHINESE_SIMPLIFIED_CHINA
    ],
    [languages_1.Catalogs.BRAZILIAN]: [
        exports.availableInternationalization.PORTUGUESE_BRAZIL
    ]
};
exports.fallbackInternationalization = {
    [languages_1.Languages.CHINESE_SIMPLIFIED]: languages_1.Languages.CHINESE_SIMPLIFIED,
    [languages_1.Languages.ENGLISH]: languages_1.Languages.ENGLISH,
    [languages_1.Languages.FRENCH]: languages_1.Languages.FRENCH,
    [languages_1.Languages.GERMAN]: languages_1.Languages.GERMAN,
    [languages_1.Languages.ITALIAN]: languages_1.Languages.ITALIAN,
    [languages_1.Languages.PORTUGUESE]: languages_1.Languages.PORTUGUESE,
    [languages_1.Languages.RUSSIAN]: languages_1.Languages.RUSSIAN,
    [languages_1.Languages.SPANISH]: languages_1.Languages.SPANISH,
    [exports.availableInternationalization.CHINESE_SIMPLIFIED_CHINA]: languages_1.Languages.CHINESE,
    [exports.availableInternationalization.ENGLISH_UNITED_KINGDOM]: languages_1.Languages.ENGLISH,
    [exports.availableInternationalization.ENGLISH_UNITED_STATES]: languages_1.Languages.ENGLISH,
    [exports.availableInternationalization.FRENCH_FRANCE]: languages_1.Languages.FRENCH,
    [exports.availableInternationalization.GERMAN_GERMANY]: languages_1.Languages.GERMAN,
    [exports.availableInternationalization.ITALIAN_ITALY]: languages_1.Languages.ITALIAN,
    [exports.availableInternationalization.PORTUGUESE_BRAZIL]: languages_1.Languages.PORTUGUESE,
    [exports.availableInternationalization.PORTUGUESE_PORTUGAL]: languages_1.Languages.PORTUGUESE,
    [exports.availableInternationalization.RUSSIAN_RUSSIA]: languages_1.Languages.RUSSIAN,
    [exports.availableInternationalization.SPANISH_SPAIN]: languages_1.Languages.SPANISH
};
exports.fallbackMainHreflang = {
    [languages_1.Languages.CHINESE_SIMPLIFIED]: exports.availableInternationalization.CHINESE_SIMPLIFIED_CHINA,
    [languages_1.Languages.ENGLISH]: exports.availableInternationalization.ENGLISH_UNITED_KINGDOM,
    [languages_1.Languages.FRENCH]: exports.availableInternationalization.FRENCH_FRANCE,
    [languages_1.Languages.GERMAN]: exports.availableInternationalization.GERMAN_GERMANY,
    [languages_1.Languages.ITALIAN]: exports.availableInternationalization.ITALIAN_ITALY,
    [languages_1.Languages.RUSSIAN]: exports.availableInternationalization.RUSSIAN_RUSSIA,
    [languages_1.Languages.SPANISH]: exports.availableInternationalization.SPANISH_SPAIN,
    [exports.availableInternationalization.CHINESE_SIMPLIFIED_CHINA]: exports.availableInternationalization.CHINESE_SIMPLIFIED_CHINA,
    [exports.availableInternationalization.ENGLISH_UNITED_KINGDOM]: exports.availableInternationalization.ENGLISH_UNITED_KINGDOM,
    [exports.availableInternationalization.ENGLISH_UNITED_STATES]: exports.availableInternationalization.ENGLISH_UNITED_STATES,
    [exports.availableInternationalization.FRENCH_FRANCE]: exports.availableInternationalization.FRENCH_FRANCE,
    [exports.availableInternationalization.GERMAN_GERMANY]: exports.availableInternationalization.GERMAN_GERMANY,
    [exports.availableInternationalization.ITALIAN_ITALY]: exports.availableInternationalization.ITALIAN_ITALY,
    [exports.availableInternationalization.RUSSIAN_RUSSIA]: exports.availableInternationalization.RUSSIAN_RUSSIA,
    [exports.availableInternationalization.SPANISH_SPAIN]: exports.availableInternationalization.SPANISH_SPAIN
};
exports.hreflangVariationsFromMain = {
    [exports.availableInternationalization.CHINESE_SIMPLIFIED_CHINA]: [
        exports.availableInternationalization.CHINESE_SIMPLIFIED_CHINA,
        'zh-TW',
        'zh-HK',
        'zh-MO'
    ],
    [exports.availableInternationalization.ENGLISH_UNITED_KINGDOM]: [
        exports.availableInternationalization.ENGLISH_UNITED_KINGDOM,
        'x-default'
    ],
    [exports.availableInternationalization.FRENCH_FRANCE]: [
        exports.availableInternationalization.FRENCH_FRANCE,
        'fr-BE',
        'fr-CH',
        'fr-LU',
        'fr-MA',
        'fr-ML',
        'fr-MU',
        'fr-NE',
        'fr-SN',
        'fr-TN',
        'fr-CA',
        'fr-CF',
        'fr-CI',
        'fr-CM',
        'fr-GN',
        'fr-GQ'
    ],
    [exports.availableInternationalization.GERMAN_GERMANY]: [
        exports.availableInternationalization.GERMAN_GERMANY,
        'de-AT',
        'de-CH',
        'de-LI',
    ],
    [exports.availableInternationalization.ITALIAN_ITALY]: [
        exports.availableInternationalization.ITALIAN_ITALY,
        'it-CH'
    ],
    [exports.availableInternationalization.RUSSIAN_RUSSIA]: [
        exports.availableInternationalization.RUSSIAN_RUSSIA
    ],
    [exports.availableInternationalization.SPANISH_SPAIN]: [
        exports.availableInternationalization.SPANISH_SPAIN,
        'es-MX',
        'es-CL',
        'es-CO',
        'es-HR',
        'es-AN',
        'es-SV',
        'es-PR',
        'es-DO',
        'es-EC',
        'es-GT',
        'es-PE',
        'es-BO',
        'es-NI',
        'es-VE',
        'es-PA',
        'es-CR',
        'es-UY',
        'es-PY'
    ]
};
// ordered exchangeable languages array
exports.chineseExchangeableLanguages = [
    languages_1.Languages.CHINESE_SIMPLIFIED,
    languages_1.Languages.CHINESE
];
exports.modalRedirectsLanguagesSirman = new Map([
    // [availableInternationalization.ENGLISH_UNITED_STATES, ''],
    [exports.availableInternationalization.PORTUGUESE_BRAZIL, 'https://www.ifmbrasil.com/'],
]);
exports.modalRedirectsLanguagesFelsinea = new Map([
    [exports.availableInternationalization.ENGLISH_UNITED_STATES, ''], // TODO: insert correct links
    [exports.availableInternationalization.PORTUGUESE_BRAZIL, ''], // TODO: insert correct links
]);
exports.defaultLanguages = [
    languages_1.DefaultLanguages.DEFAULT,
    languages_1.DefaultLanguages.X_DEFAULT
];
//# sourceMappingURL=languages.js.map